import { render, staticRenderFns } from "./SingleOwnerView.vue?vue&type=template&id=45863462&"
import script from "./SingleOwnerView.vue?vue&type=script&lang=js&"
export * from "./SingleOwnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports